import { MenuItem } from '@mui/joy';
import { PropsWithChildren, ReactElement } from 'react';
import { useHistory } from 'react-router-dom';

interface IMenuItemProps {
  id?: string;
  linkTo: string;
  disabled?: boolean;
  title?: string;
}

export const DropdownLinkItem = ({ id, linkTo, disabled, title, children }: PropsWithChildren<IMenuItemProps>): ReactElement => {
  const history = useHistory();

  const pushToHistory = (): void => {
    history.push(linkTo);
  };

  return (
    <MenuItem
      onClick={pushToHistory}
      title={title}
      id={id}
      disabled={disabled}
    >
      {children}
    </MenuItem>
  );
};
